module.exports = __webpack_public_path__ + "img/plane-ticket.c034a5ca.svg";